import { websockets } from '../../engine/websockets-sidecar'
import { l } from '../../lib/imports'
import { rando } from '../../lib/rando-sidecar'
import { createId } from '../../main/common'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { EVoyageCrewCreateMethod } from './multi/voyageMessageCrewCreate'
import { voyageMessageCrewCreate } from './multi/voyageMessageCrewCreate-sidecar'
import { EVoyageCrewDamageType } from './multi/voyageMessageCrewHurt'
import { voyageStarmapGenerator } from './starmap/voyageStarmapGenerator-sidecar'
import { voyageBullets } from './voyageBullets-sidecar'
import { voyageCamera } from './voyageCamera-sidecar'
import { voyageCamera_zoomer } from './voyageCamera_zoomer-sidecar'
import { voyageCarryable } from './voyageCarryable-sidecar'
import { EVoyageCrewType } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageFakeInfo } from './voyageFakeInfo-sidecar'
import { voyageGameManager } from './voyageGameManager-sidecar'
import { voyageGameMode_game_director } from './voyageGameMode_game_director-sidecar'
import { voyageGameMode_tutorial } from './voyageGameMode_tutorial-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageGameStatus_enemyShips } from './voyageGameStatus_enemyShips-sidecar'
import { voyageMenuMain } from './voyageMenuMain-sidecar'
import { voyageParticles } from './voyageParticles-sidecar'
import { voyageSaver } from './voyageSaver-sidecar'
import { voyageSplatters } from './voyageSplatters-sidecar'
import type { IVoyageSystemData } from './voyageSystemsData'
import { EVoyageTile } from './voyageTileData'
import { voyageTilemap } from './voyageTilemap-sidecar'
import { voyageUiGame } from './voyageUiGame-sidecar'
import { voyageUiMessage } from './voyageUiMessage-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

const namespace = 'voyage-game'

export function reset() {
  console.log('!! GAME RESET')
  voyageFakeInfo.reset()
  voyageCrew.killAll()
  voyageBullets.killAll()
  voyageParticles.killAll()
  voyageSplatters.killAll()
  voyageCarryable.killAll()
  voyageUiMessage.setOpen(false)
  voyageGameStatus.reset()
  initWorld()
}

let _worldInited = false
export function* generator_initWorld() {
  if (_worldInited) {
    return
  }

  while (!voyageSaver.getIsLoaded()) {
    yield 0
  }

  if (!voyageWebsockets.getIsSingleplayer()) {
    while (websockets.isStillConnecting()) {
      yield 0
    }
  }

  voyageUiGame.setOpen(true)

  // initWorld()
  reset()

  _worldInited = true
}

function initWorld() {
  let id = 0

  let isHost = voyageWebsockets.getIsHost()

  // Reset starmap
  voyageStarmapGenerator.generateStarmap()

  // Reset tilemap systems
  voyageTilemap.resetSystems()

  l.forEach(voyageTilemap.get().parts, (c) => {
    let hide = false
    let killText = false
    if (c.tile3.type === EVoyageTile.CrewSpawn) {
      hide = true

      if (isHost) {
        voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
          crewId: createId(),
          i: c.i,
          j: c.j,
          team: 0,
          type: EVoyageCrewType.Crew,
          method: EVoyageCrewCreateMethod.Normal,
          name: voyageFakeInfo.genFakeName(),
          energy: rando.i(100, voyageCrew.maxEnergy),
        })
      }
    }
    if (c.tile3.type === EVoyageTile.Text) {
      hide = true
    }

    let sys: IVoyageSystemData | null = null
    if (c.tile3.type === EVoyageTile.Elevator) {
      voyageTilemap.addGameElevator(c)
      id++
      sys = voyageTilemap.addGameSystem2(c, 'elevator-' + id)
    }

    if (c.tile3.type === EVoyageTile.System) {
      sys = voyageTilemap.addGameSystem(c)
    }
    if (c.tile3.type === EVoyageTile.MedPad) {
      sys = voyageTilemap.addGameSystem(c)
    }

    // Post-process some systems
    if (sys) {
      if (sys.killText) {
        killText = true
      }
      if (sys.hide) {
        hide = true
      }
    }

    if (c.tile3.type === EVoyageTile.Test) {
      hide = true

      if (c.text3 === 'camera') {
        hide = true
        killText = true
        voyageCamera.centerOn(c.x, c.y)
      }

      if (!isHost) {
        hide = true
        killText = true
      }
      if (isHost) {
        if (c.text3 === 'fire') {
          hide = true
          killText = true
          let cr = voyageCrew.create(EVoyageCrewType.Fire, -1)
          voyageCrew.moveToIJ(cr, c)
        }

        if (c.text3 === 'indie') {
          hide = true
          killText = true

          voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
            crewId: createId(),
            i: c.i,
            j: c.j,
            team: 0,
            type: EVoyageCrewType.Animal,
            method: EVoyageCrewCreateMethod.Normal,
            name: 'Indie', //
            energy: rando.i(100, voyageCrew.maxEnergy),
          })

          // let cr = voyageCrew.create(EVoyageCrewType.Animal, 0)
          // voyageCrew.moveToIJ(cr, c)
        }

        if (c.text3 === 'alien') {
          hide = true
          killText = true
          let cr = voyageCrew.create(EVoyageCrewType.Alien, 1)
          voyageCrew.moveToIJ(cr, c)
        }

        if (c.text3 === 'breach') {
          hide = true
          killText = true
          let cr = voyageCrew.create(EVoyageCrewType.HullBreach, -1)
          voyageCrew.moveToIJ(cr, c)

          // voyageTilemapPart.setHullBreach(c, true)
        }

        if (c.text3 === 'dead') {
          hide = true
          killText = true

          if (rando.chance(0.5)) {
            let cr = voyageCrew.create(EVoyageCrewType.Crew, 0)
            voyageCrew.moveToIJ(cr, c)
            voyageCrew.hurt(cr, 100, EVoyageCrewDamageType.FoundLikeThat, 0) //  'Found dead')
          } else {
            let cr = voyageCrew.create(EVoyageCrewType.Alien, 0)
            voyageCrew.moveToIJ(cr, c)
            voyageCrew.hurt(cr, 100, EVoyageCrewDamageType.FoundLikeThat, 0) //, 'Found dead')
          }

          // voyageTilemapPart.setHullBreach(c, true)
        }

        if (c.text3 === 'es-hammerhead') {
          hide = true
          killText = true
          voyageGameStatus_enemyShips.createHammerheadClass()
        }
      }
    }

    if (c.image3 && hide) {
      c.image3.visible = false
    }
    if (c.text && killText) {
      stevieTexts2.kill(c.text)
      c.text = null
    }
  })
}

export function* generator_afterLoad(): Generator<number, number, number> {
  let afterLoads = voyageGameManager.get().afterLoad
  while (afterLoads.length > 0) {
    let action = afterLoads.shift()
    if (action) {
      action()
    }
  }
  return 0
}

export function* generator_game(): Generator<number, number, number> {
  console.log(namespace, 'starting game!!')

  voyageMenuMain.setOpen(false)

  yield* generator_initWorld()

  // voyagePicker.selectFirstCrew()
  yield* generator_afterLoad()

  // if (!_skipTutorial) {
  yield* voyageGameMode_tutorial.generator_tutorial()
  // }

  // console.log('flippo')
  //while (true) {
  yield* voyageGameMode_game_director.generator_director()

  // generalGameLoop()
  //yield 0
  //}
  return 0
}

export function generalGameLoop() {
  // console.log('flippo')
}
